import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Users } from 'lucide-react';
import { UseFormReturn } from 'react-hook-form';
import { ClassFormValues } from '../ClassForm';

export interface CapacityFieldsProps {
  form: UseFormReturn<ClassFormValues>;
  handleCapacityChange: (value: string) => void;
}

export const CapacityFields: React.FC<CapacityFieldsProps> = ({ 
  form, 
  handleCapacityChange 
}) => {
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="capacity"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-sm font-medium flex items-center gap-2">
              <Users className="h-4 w-4" />
              Max Students
            </FormLabel>
            <FormControl>
              <Input
                id="capacity"
                type="number"
                min={1}
                value={field.value || ''}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow empty string for clearing the field
                  if (value === '') {
                    field.onChange('');
                  } else {
                    handleCapacityChange(value);
                  }
                }}
                onBlur={(e) => {
                  // If field is empty on blur, set to 1
                  if (e.target.value === '') {
                    handleCapacityChange('1');
                  }
                }}
                className="h-11"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="waitlistEnabled"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
            <div className="space-y-0.5">
              <FormLabel className="text-base">Enable Waitlist</FormLabel>
              <div className="text-sm text-muted-foreground">
                Automatically notify families when spots become available
              </div>
            </div>
            <FormControl>
              <Switch
                checked={field.value ?? true}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
};
